import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgNoAccess(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("path", {
      d: "M49.279 61C55.752 61 61 55.806 61 49.4c0-6.407-5.248-11.6-11.721-11.6s-11.721 5.194-11.721 11.6c0 6.407 5.248 11.6 11.72 11.6z",
      stroke: "#FF6652",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), _jsx("path", {
      d: "M57.845 41.37L40.714 57.43",
      stroke: "#FF6652",
      strokeWidth: 3
    }, void 0), _jsx("path", {
      d: "M40.787 28.823a1.5 1.5 0 003 0h-3zm7.795 3.787a1.5 1.5 0 103 0h-3zm-7.795-17.442v13.655h3V15.168h-3zM51.582 32.61V15.168h-3V32.61h3zM46.184 9.77a5.398 5.398 0 00-5.397 5.398h3a2.398 2.398 0 012.397-2.397v-3zm0 3a2.398 2.398 0 012.398 2.398h3a5.398 5.398 0 00-5.398-5.397v3zM18.646 35.596c.39.73 1.302 1.01 2.037.626a1.483 1.483 0 00.623-2.018l-2.66 1.392zm-3.065-8.913l-1.347.665.008.016.008.015 1.33-.696zm17.587 29.044c.832 0 1.504-.669 1.5-1.494a1.507 1.507 0 00-1.511-1.493l.011 2.987zm-8.182-1.494l-.006-1.493.006 1.493zM7.919 30.046l-1.328.7 1.328-.7zm13.387 4.158l-4.395-8.216-2.66 1.391 4.395 8.217 2.66-1.392zm-4.379-8.185c-.787-1.558-1.71-2.748-2.881-3.479-1.215-.757-2.523-.912-3.838-.724l.444 2.957c.775-.112 1.32-.003 1.797.294.52.325 1.128.98 1.785 2.281l2.693-1.33zM6.591 30.746l11.132 20.656 2.656-1.4L9.247 29.346l-2.656 1.4zm18.4 24.98h8.177l-.011-2.986H24.98l.012 2.987zm-7.268-4.324a8.257 8.257 0 007.269 4.325l-.012-2.987a5.227 5.227 0 01-4.6-2.738l-2.657 1.4zm-7.515-29.586c-2.163.311-3.542 1.827-4.115 3.553-.562 1.694-.407 3.698.498 5.377l2.656-1.4c-.517-.959-.596-2.116-.292-3.033.293-.882.881-1.423 1.697-1.54l-.444-2.957z",
      fill: "#7373FF"
    }, void 0), _jsx("path", {
      d: "M24.362 27.19a1.5 1.5 0 003 0h-3zm-7.795 3.843a1.5 1.5 0 103 0h-3zm7.795-20.875V27.19h3V10.158h-3zm-4.795 20.875V10.158h-3v20.875h3zm2.397-23.268a2.397 2.397 0 012.398 2.393h3a5.397 5.397 0 00-5.398-5.393v3zm0-3a5.397 5.397 0 00-5.397 5.393h3a2.397 2.397 0 012.397-2.393v-3z",
      fill: "#7373FF"
    }, void 0), _jsx("path", {
      d: "M32.714 27.19a1.5 1.5 0 003 0h-3zm-8.352 0a1.5 1.5 0 003 0h-3zm8.352-20.014V27.19h3V7.176h-3zM27.362 27.19V7.176h-3V27.19h3zM30.038 4.5a2.676 2.676 0 012.676 2.676h3A5.676 5.676 0 0030.038 1.5v3zm0-3a5.676 5.676 0 00-5.676 5.676h3A2.676 2.676 0 0130.038 4.5v-3z",
      fill: "#7373FF"
    }, void 0), _jsx("path", {
      d: "M40.787 29.16a1.5 1.5 0 003 0h-3zm-8.074-2.66a1.5 1.5 0 003 0h-3zm8.074-17.286V29.16h3V9.214h-3zM35.713 26.5V9.214h-3V26.5h3zM38.25 6.677a2.537 2.537 0 012.537 2.537h3a5.537 5.537 0 00-5.537-5.537v3zm0-3a5.537 5.537 0 00-5.537 5.537h3a2.537 2.537 0 012.537-2.537v-3z",
      fill: "#7373FF"
    }, void 0)]
  }), void 0);
}

export default SvgNoAccess;